import * as React from "react";

function SvgUpArrow(props) {
  return <svg width="1em" height="1em" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12.9 9.6L7.5 4.2 2.1 9.6 0 7.5 7.5 0 15 7.5l-2.1 2.1z" fill="#F2F2F2" /></svg>;
}

export default SvgUpArrow;